<!-- header-documento-final-proposta.component.html -->
<div id="documento-aditivo-container-header" class="documento-aditivo-container">
  <div class="header" style="margin-bottom: 0px">
    <div class="logo-operadora d-flex justify-content-center col-12">
      <ng-container *ngIf="dadosOperadoraCabecalho?.dadosEntidade?.heUdemo; else logoPadrao">
        <ng-container *ngIf="!dadosOperadoraCabecalho?.ehInclusaoDependente; else logoUdemoInclusaoDependente">
          <img [src]="operadoraVM?.logoAditivoUDEMO" alt="Logo " class="logo-img" />
        </ng-container>
      </ng-container>

      <ng-template #logoUdemoInclusaoDependente>
        <img
          [src]="operadoraVM?.logoInclusaoDependenteUdemo"
          alt="Logo UDEMO Inclusão de Dependentes"
          class="logo-img" />
      </ng-template>

      <ng-template #logoPadrao>
        <ng-container *ngIf="!dadosOperadoraCabecalho?.ehInclusaoDependente; else logoPadraoInclusaoDependente">
          <img [src]="operadoraVM?.logoAditivo" alt="Logo Padrão" class="logo-img" />
        </ng-container>
      </ng-template>

      <ng-template #logoPadraoInclusaoDependente>
        <img [src]="operadoraVM?.logoInclusaoDependente" alt="Logo Inclusão de Dependentes" class="logo-img" />
      </ng-template>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-md-8 d-flex display-mobile titula-header-margem">
      <div class="col-md-4">
        <p class="text-center"><b>Entidade</b></p>
        <p style="font-size: 14px" class="text-center">{{ entidadeProposta }} - {{ razaoSocialEntidade }}</p>
      </div>
      <div class="col-md-4">
        <p class="text-center"><b>Nº da Proposta</b></p>
        <p class="text-center">{{ codigoProposta }}</p>
      </div>
      <div class="col-md-4">
        <ng-container *ngIf="vigenciaProposta">
          <p class="text-center"><b>Vigência</b></p>
          <p class="text-center">{{ vigenciaProposta }}</p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
